import React from "react";
import classNames from "classnames";
import { Box, Edit } from "react-feather";
import { toast } from "react-toastify";

import { TableButton } from "components/TableButton";

import "./cutLink.scss";

export const CutLink = ({
  children,
  copyText = null,
  width = false,
  onClick = null,
  nomenclature = null
}) => {

  const copy = async (children) => {

    if (typeof children !== 'string' && !copyText) return;

    const text = copyText ?? children;

    try {
      await navigator.clipboard.writeText(text.replace(/<[^>]*>/g, ''));
      toast.success(`${text} скопирован в буфер обмена`);
    } catch (err) {
      toast.error('Ошибка при копировании текста: ' + err);
    }
  };

  const openStock = () => {
    window.open(`/stock/stock?nomenclature=${nomenclature?.id}&article=${nomenclature?.article}&brand=${nomenclature?.brand}`, "_blank");
  }

  return (
    <div className={classNames("cutLink", { "width": width })}>
      <span>{children}</span>
      <div className="cutLink__hover">
        <div className={classNames("cutLink__text", { "cursor": typeof children === 'string' || copyText })} onClick={() => copy(children)}>
          {children}
        </div>
        {onClick &&
          <div className="cutLink__buttons">
            <TableButton Icon={Edit} onClick={onClick} />
            <TableButton Icon={Box} onClick={openStock} />
          </div>
        }
      </div>
    </div>
  );
};
